var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ib-info-modal',{attrs:{"id":_vm.id,"title":"Listings Manager","iconColour":"secondary"}},[_vm._v(" Help Text Here : "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }